module.exports = function () {

    if ($('.module').length === 0) {
        return;
    }

    function updateAosAttributes($element, index, parentShouldOffsetDelayDefault, parentTransitionDelay, parentTransitionDuration) {
        var delay = 0;
        var duration = 1000;
        var shouldOffsetDelay = true;

        if (parentTransitionDelay != undefined) {
            delay = parentTransitionDelay;
        }
        else {
            var transitionDelay = $element.data('transitionDelay');
            if (transitionDelay != undefined) {
                delay = transitionDelay;
            }
        }

        if (parentTransitionDuration != undefined) {
            duration = parentTransitionDuration;
        }
        else {
            var transitionDuration = $element.data('transitionDuration');
            if (transitionDuration != undefined) {
                duration = transitionDuration;
            }
        }        
        
        if ($element.is('[data-transition-delay-offset]')) {
            shouldOffsetDelay = $element.data('transitionDelayOffset');
        }
        else if (parentShouldOffsetDelayDefault != undefined) {
            shouldOffsetDelay = parentShouldOffsetDelayDefault;
        }

        if (shouldOffsetDelay) {
            var offsetIndex = index || 0;

            if ($element.is('[data-transition-delay-offset-index]')) {
                offsetIndex = $element.data('transitionDelayOffsetIndex');
            }

            delay = delay + (offsetIndex * 100);
        }

        $element.attr('data-aos-duration', duration);
        $element.attr('data-aos-delay', delay);
                        
        var $nextLevelAosDescendants = $element.find('[data-aos]').filter(function (index) {
            var $closestAosAncestor = $(this).parent().closest('[data-aos]');
            var isFirstOrNextLevelDescendant = $closestAosAncestor.length == 0 || $closestAosAncestor[0] == $element[0];
            return isFirstOrNextLevelDescendant;
        });

        if ($nextLevelAosDescendants.length) {
            var shouldOffsetDelayDefault = shouldOffsetDelay;
            if ($element.is('[data-transition-delay-offset-subitems]')) {
                shouldOffsetDelay = $element.data('transitionDelayOffsetSubitems');
            }

            $nextLevelAosDescendants.each(function (descendantIndex) {
                updateAosAttributes($(this), descendantIndex, shouldOffsetDelayDefault, delay, duration);
            });
        }
    }

    function resetModuleAnimateOnScrollDelays() {
        $('.module').each(function () {
            updateAosAttributes($(this), 0);
        });

        if (window.aos != undefined) {
            window.aos.refresh();
        }
    }

    resetModuleAnimateOnScrollDelays();

    $(window).resize(function () {
        resetModuleAnimateOnScrollDelays();
    });
};